/* global $ */

import DesignApproachSection from './DesignApproachSection';

class PageService {
  constructor(mainApp) {
    this.$window = $(window);
    console.log('PageService');
    this.mainApp = mainApp;
    this.content = new DesignApproachSection($('.Section--designApproach'));
  }
  onLoadWindow() {}
  onWindowResize() {}
  onWindowScroll() {}
  destroy() {}
}

export default PageService;
